// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Top-level section tabs — Projects / Node Catalog / Data Catalog. Sits directly
   under GlobalPageHeader on every section page. */

.dLjhbXwOHziCya36W250 {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 20px;
  min-height: 48px;
  background: #fafafa;
  border-bottom: 1px solid #e5e5e5;
}

.w25bC1HYMld4s7OqBVnv {
  padding: 8px 16px;
  border: 1px solid #d0d0d5;
  border-radius: 4px;
  background: #fff;
  font-size: 13px;
  font-weight: 500;
  color: #6b6b76;
  text-decoration: none;
  cursor: pointer;
  font-family: inherit;
  opacity: 1;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

/* Do not apply inactive-tab hover colors to the active tab (avoids “washed out” / fake opacity). */
.w25bC1HYMld4s7OqBVnv:hover:not(.Jqt3FhqTkMc9rDXoBNxP) {
  border-color: #b0b0b8;
  color: #1e1f23;
  background: #f7f7f7;
}

.Jqt3FhqTkMc9rDXoBNxP {
  background: #1e1f23;
  border-color: #1e1f23;
  color: #fbfcf6;
  font-weight: 600;
}

.Jqt3FhqTkMc9rDXoBNxP:hover {
  color: var(--curio-text-on-dark);
  background: var(--curio-top-bar-bg-hover);
  border-color: var(--curio-top-bar-bg-hover);
  opacity: 1;
}

.w25bC1HYMld4s7OqBVnv:focus-visible {
  outline: 2px solid var(--curio-focus-ring);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/AppSectionTabs.module.css"],"names":[],"mappings":"AAAA;kDACkD;;AAElD;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,UAAU;EACV,kFAAkF;AACpF;;AAEA,mGAAmG;AACnG;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,yCAAyC;EACzC,2CAA2C;EAC3C,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB","sourcesContent":["/* Top-level section tabs — Projects / Node Catalog / Data Catalog. Sits directly\n   under GlobalPageHeader on every section page. */\n\n.tabBar {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 20px;\n  min-height: 48px;\n  background: #fafafa;\n  border-bottom: 1px solid #e5e5e5;\n}\n\n.tabLink {\n  padding: 8px 16px;\n  border: 1px solid #d0d0d5;\n  border-radius: 4px;\n  background: #fff;\n  font-size: 13px;\n  font-weight: 500;\n  color: #6b6b76;\n  text-decoration: none;\n  cursor: pointer;\n  font-family: inherit;\n  opacity: 1;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n/* Do not apply inactive-tab hover colors to the active tab (avoids “washed out” / fake opacity). */\n.tabLink:hover:not(.tabLinkActive) {\n  border-color: #b0b0b8;\n  color: #1e1f23;\n  background: #f7f7f7;\n}\n\n.tabLinkActive {\n  background: #1e1f23;\n  border-color: #1e1f23;\n  color: #fbfcf6;\n  font-weight: 600;\n}\n\n.tabLinkActive:hover {\n  color: var(--curio-text-on-dark);\n  background: var(--curio-top-bar-bg-hover);\n  border-color: var(--curio-top-bar-bg-hover);\n  opacity: 1;\n}\n\n.tabLink:focus-visible {\n  outline: 2px solid var(--curio-focus-ring);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabBar": `dLjhbXwOHziCya36W250`,
	"tabLink": `w25bC1HYMld4s7OqBVnv`,
	"tabLinkActive": `Jqt3FhqTkMc9rDXoBNxP`
};
export default ___CSS_LOADER_EXPORT___;
